module.exports = __webpack_public_path__ + "img/bg11.275601b0.png";